import { useState } from "react"
import { router, usePage } from "@inertiajs/react"
import Button from "@/components/Button"
import useUser from "@/hooks/useUser"
import { GameShowProps } from "@/types/types"

const ImportButton = () => {
  const { game } = usePage<GameShowProps>().props
  const { user } = useUser()
  const [processing, setProcessing] = useState(false)

  if (!user) return null

  const handleImport = () => {
    router.post(
      `/games/${game.id}/import`,
      {},
      {
        onStart: () => setProcessing(true),
        onFinish: () => setProcessing(false),
      }
    )
  }

  return (
    <Button size="sm" onClick={handleImport} loading={processing}>
      Import game
    </Button>
  )
}

export default ImportButton
